import React, { useState, useContext } from "react";

import MenuItem from "@material-ui/core/MenuItem";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import {
  Menu,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@material-ui/core";
import { toast } from "react-toastify";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import ForwardMessageModal from "../ForwardMessageModal";
import toastError from "../../errors/toastError";

const ACK_LABELS = {
  0: "Pendente (relógio)",
  1: "Enviada ao servidor (✓)",
  2: "Entregue no aparelho (✓✓)",
  3: "Lida (✓✓ azul)",
  4: "Reproduzida (áudio)"
};

const formatInfoDate = value => {
  if (!value) return "-";
  try {
    return new Date(value).toLocaleString("pt-BR");
  } catch (err) {
    return String(value);
  }
};

const MessageOptionsMenu = ({ message, menuOpen, handleClose, anchorEl }) => {
  const { setReplyingMessage, setEditingMessage } = useContext(
    ReplyMessageContext
  );
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [infoOpen, setInfoOpen] = useState(false);
  const [forwardOpen, setForwardOpen] = useState(false);

  const handleCopyMessage = async () => {
    try {
      await navigator.clipboard.writeText(message.body || "");
      toast.success("Mensagem copiada!");
    } catch (err) {
      toastError(err);
    }
    handleClose();
  };

  const handleOpenInfo = () => {
    setInfoOpen(true);
    handleClose();
  };

  const handleForward = () => {
    setForwardOpen(true);
    handleClose();
  };

  const handleDeleteMessage = async () => {
    try {
      await api.delete(`/messages/${message.id}`);
    } catch (err) {
      toastError(err);
    }
  };

  const handleReact = async emoji => {
    try {
      await api.post(`/messages/${message.id}/react`, { emoji });
    } catch (err) {
      toastError(err);
    }
    handleClose();
  };

  const hanldeReplyMessage = () => {
    setReplyingMessage(message);
    handleClose();
  };

  const handleEditMessage = () => {
    setEditingMessage(message);
    handleClose();
  };

  const handleOpenConfirmationModal = (e) => {
    setConfirmationOpen(true);
    handleClose();
  };

  return (
    <>
      <ConfirmationModal
        title={i18n.t("messageOptionsMenu.confirmationModal.title")}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteMessage}
      >
        {i18n.t("messageOptionsMenu.confirmationModal.message")}
      </ConfirmationModal>
      <ForwardMessageModal
        modalOpen={forwardOpen}
        onClose={() => setForwardOpen(false)}
        message={message}
      />
      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={menuOpen}
        onClose={handleClose}
      >
        {message.fromMe && (
          <MenuItem onClick={handleOpenConfirmationModal}>
            {i18n.t("messageOptionsMenu.delete")}
          </MenuItem>
        )}
        <MenuItem onClick={hanldeReplyMessage}>
          {i18n.t("messageOptionsMenu.reply")}
        </MenuItem>
        {message.fromMe && !message.mediaUrl && !message.isDeleted && (
          <MenuItem onClick={handleEditMessage}>Editar</MenuItem>
        )}
        <MenuItem onClick={handleCopyMessage}>Copiar</MenuItem>
        <MenuItem onClick={handleForward}>Encaminhar</MenuItem>
        <MenuItem onClick={handleOpenInfo}>Dados da mensagem</MenuItem>
        <div
          style={{
            display: "flex",
            gap: 4,
            padding: "6px 12px",
            justifyContent: "center"
          }}
        >
          {["👍","❤️","😂","😮","😢","🙏"].map(emoji => (
            <span
              key={emoji}
              role="button"
              onClick={() => handleReact(emoji)}
              style={{
                cursor: "pointer",
                fontSize: 20,
                lineHeight: "24px",
                padding: 2
              }}
            >
              {emoji}
            </span>
          ))}
        </div>
      </Menu>
      <Dialog
        open={infoOpen}
        onClose={() => setInfoOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Dados da mensagem</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" gutterBottom>
            <strong>Status:</strong>{" "}
            {message.isDeleted
              ? "Apagada"
              : ACK_LABELS[message.ack] || `ack ${message.ack}`}
          </Typography>
          <Typography variant="body2" gutterBottom>
            <strong>Enviada em:</strong> {formatInfoDate(message.createdAt)}
          </Typography>
          <Typography variant="body2" gutterBottom>
            <strong>Última atualização:</strong>{" "}
            {formatInfoDate(message.updatedAt)}
          </Typography>
          <Typography variant="body2" gutterBottom>
            <strong>De:</strong> {message.fromMe ? "Você (atendimento)" : message.contact?.name || "Cliente"}
          </Typography>
          {message.mediaType && message.mediaType !== "chat" ? (
            <Typography variant="body2" gutterBottom>
              <strong>Tipo:</strong> {message.mediaType}
            </Typography>
          ) : null}
          <Typography
            variant="body2"
            style={{ marginTop: 8, color: "#667781", whiteSpace: "pre-wrap" }}
          >
            {(message.body || "").slice(0, 400)}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MessageOptionsMenu;
